// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from '../../utils/axios';
import utils from '../../utils/utils';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const BASE_URL = process.env.REACT_APP_BASE_API_URL;
const PATH = 'workout-tags';
const navigateTo = '/workout-tags';

const initialState = {
    workoutTags: [],
    workoutTagsObject: [],
    error: null,
    totalPages: 1,
    loading: false,
    limit: 10,
    currentPage: 1
};

// Reducer
const slice = createSlice({
    name: 'workoutTags',
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload;
            state.loading = false;
        },

        startLoading(state, action) {
            state.loading = true;
        },
        stopLoading(state, action) {
            state.loading = false;
        },

        // GET USERS STYLE 1
        getSuccess(state, action) {
            const data = action.payload.data;
            state.workoutTags = utils.sortAlphatically(data, 'name');
            state.workoutTagsObject = utils.getUniqueObject(data, 'id');
            const total = action.payload.totalItems;
            let pages = Math.floor(total / state.limit);
            const remainder = total % state.limit;
            if (remainder !== 0) {
                pages += 1;
            }
            state.totalPages = pages;
            state.loading = false;
        },
        addSuccess(state, action) {
            state.loading = false;
        },
        editSuccess(state, action) {
            state.loading = false;
        },
        deleteSuccess(state, action) {
            state.loading = false;
            state.locations = state.workoutTags.filter((item) => item.id !== action.payload.id);
        },
        setCurrentPage(state, action) {
            console.log(action.payload);
            state.currentPage = action.payload;
        }
    }
});

export default slice.reducer;

// Actions

export function startLoading() {
    return async () => {
        dispatch(slice.actions.startLoading());
    };
}

export function stopLoading() {
    return async () => {
        dispatch(slice.actions.stopLoading());
    };
}

export function getWorkoutTags() {
    return async () => {
        try {
            const result = await axios.get(`/${PATH}?size=1000`);
            console.log('RES [getWorkoutTags]:', result.data);
            dispatch(slice.actions.getSuccess(result.data));
        } catch (error) {
            console.log('ERR [getWorkoutTags]:', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function addWorkoutTag(data, navigate) {
    return async () => {
        try {
            const result = await axios.post(`/${PATH}`, data);
            console.log('RES [addWorkoutTag] ======> ', result.data.data);
            dispatch(slice.actions.addSuccess(result.data.data));
            navigate(navigateTo);
        } catch (error) {
            console.log('ERR [addWorkoutTag] =======> ', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function editWorkoutTag(id, data, navigate) {
    return async () => {
        try {
            const result = await axios.put(`/${PATH}/${id}`, data);
            console.log('RES [editWorkoutTag] =======> ', result?.data?.data);
            dispatch(slice.actions.editSuccess(result?.data?.data));
            navigate(navigateTo);
        } catch (error) {
            console.log('ERR [editWorkoutTag] ', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function deleteWorkoutTag(id = '') {
    return async () => {
        try {
            const result = await axios.delete(`/${PATH}/${id}`);
            console.log('RES [deleteWorkoutTag] =======> ', result);
            dispatch(slice.actions.deleteSuccess(result.data.data));
            dispatch(getWorkoutTags())
        } catch (error) {
            dispatch(getWorkoutTags())
            console.log('ERR [deleteWorkoutTag] =========> ', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function setCurrentPage(page) {
    return async () => {
        dispatch(slice.actions.setCurrentPage(page));
    };
}
